import { Box, styled } from "@mui/material";
export const TooltipContent = styled(Box) `
    gap: 6px;
    display: flex;
`;
//# sourceMappingURL=TooltipContent.js.map